import { useTranslation } from "react-i18next";
import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { IdentityFields } from "./PersonalData/IdentityFields";
import { DemographicFields } from "./PersonalData/DemographicFields";
import { StatusFields } from "./PersonalData/StatusFields";
import { AvatarField } from "./PersonalData/AvatarField";

/**
 * PersonalDataSection - Refactored into smaller, domain-specific components.
 */
export function PersonalDataSection({
  profile,
  setProfile,
  readOnly,
  loading
}: ProfileSectionProps) {
  const { t } = useTranslation(["talent"]);

  return (
    <FormSection title={t("forms.sections.personal_data.title")}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <IdentityFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
          loading={loading}
        />

        <DemographicFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
          loading={loading}
        />

        <AvatarField profile={profile} readOnly={readOnly} loading={loading} />

        <StatusFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
          loading={loading}
        />
      </div>
    </FormSection>
  );
}
